<template>
  <div
    class="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-[200] h-full w-full font-zona"
  >
    <div
      class="h-[90vh] w-full bg-white rounded p-5 m-5 space-y-5 overflow-x-scroll"
    >
      <div class="flex justify-end">
        <button
          @click="closeAnswers()"
          class="flex justify-center items-center bg-blue-200 h-8 w-8 rounded-full text-sm text-white hover:bg-blue-300"
        >
          <font-awesome-icon icon="fa-solid fa-x" />
        </button>
      </div>

      <div v-if="!isAnswerLoading">
        <table class="w-full text-xs">
          <thead class="bg-slate-300 text-black text-sm">
            <tr>
              <th class="border border-slate-300">№</th>
              <th class="border border-slate-300 uppercase"></th>
              <th class="border border-slate-300">Өгөгдөл</th>
              <th class="border border-slate-300 w-1/5">Үйлдэл</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td class="p-2 border border-slate-300">1</td>
              <td class="p-2 border border-slate-300">
                Хавсаргасан нотлох эх үүсвэрүүд
              </td>
              <td class="p-2 border border-slate-300">
                <ul class="flex flex-col gap-2">
                  <li v-for="file in assessmentFiles" :key="file.cid">
                    <a
                      :href="file.proof_file"
                      target="_blank"
                      class="text-gray-500 hover:underline"
                    >
                      {{ file.cid }} - {{ file.proof_file }}
                    </a>
                  </li>
                </ul>
              </td>
              <td class="p-2 border border-slate-300">
                <div class="flex justify-center items-center">
                  <button
                    @click="downloadProofFiles(assessmentResult.name)"
                    class="p-2 bg-blue-500 text-white rounded"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-download"
                      class="mr-1"
                    />
                    ZIP файл татах
                  </button>
                </div>
              </td>
            </tr>

            <tr>
              <td class="p-2 border border-slate-300">2</td>
              <td class="p-2 border border-slate-300">Албан бичиг</td>
              <td class="p-2 border border-slate-300">
                <a
                  :href="assessmentAttachment?.official_document"
                  target="_blank"
                  class="text-gray-500 hover:underline"
                >
                  {{
                    assessmentAttachment?.official_document ||
                    "No document found"
                  }}
                </a>
              </td>
              <td class="p-2 border border-slate-300">
                <div class="flex justify-center items-center">
                  <button
                    @click="
                      downloadFile(
                        assessmentAttachment?.official_document,
                        `${assessmentResult.name}-албан-бичиг`
                      )
                    "
                    class="p-2 bg-blue-500 text-white rounded"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-download"
                      class="mr-1"
                    />
                    Албан бичиг татах
                  </button>
                </div>
              </td>
            </tr>

            <tr>
              <td class="p-2 border border-slate-300">3</td>
              <td class="p-2 border border-slate-300">Маягт & тайлан</td>
              <td class="p-2 border border-slate-300">
                <a
                  :href="assessmentAttachment?.form"
                  target="_blank"
                  class="text-gray-500 hover:underline"
                >
                  {{ assessmentAttachment?.form || "No document found" }}
                </a>
              </td>
              <td class="p-2 border border-slate-300">
                <div class="flex justify-center items-center">
                  <button
                    @click="
                      downloadFile(
                        assessmentAttachment?.form,
                        `${assessmentResult.name}-маягт-тайлан`
                      )
                    "
                    class="p-2 bg-blue-500 text-white rounded"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-download"
                      class="mr-1"
                    />
                    Тайлан татах
                  </button>
                </div>
              </td>
            </tr>

            <tr>
              <td class="p-2 border border-slate-300">4</td>
              <td class="p-2 border border-slate-300">Зураг</td>
              <td class="p-2 border border-slate-300">
                <div class="flex justify-center items-center w-1/2">
                  <div ref="contentToDownload" class="relative w-full">
                    <img
                      src="@/assets/images/miningMongolia/codex_poster.jpg"
                      alt="poster"
                      class="w-full border"
                    />

                    <div
                      class="absolute inset-0 flex flex-col items-center w-full h-full mt-10 sm:mt-14 lg:mt-20"
                    >
                      <h1
                        class="font-bold uppercase text-sm min-[400px]:text-base min-[500px]:text-lg min-[1100px]:text-xl text-center"
                      >
                        Хариуцлагатай <br />
                        уул уурхайн кодекс
                      </h1>

                      <div
                        v-if="assessmentResult.logo"
                        class="flex justify-center w-full my-3 lg:my-5"
                      >
                        <img
                          :src="assessmentResult.logo"
                          alt="logo"
                          class="w-1/3 object-contain"
                        />
                      </div>
                      <h6
                        class="hidden min-[500px]:flex font-bold uppercase text-sm min-[400px]:text-base min-[500px]:text-lg"
                      >
                        өөрийн үнэлгээ
                      </h6>
                      <p class="text-6xl text-[#4bb543] font-bold">
                        {{ `${assessmentResult.main_percentage}%` }}
                      </p>
                    </div>
                  </div>
                </div>
              </td>
              <td class="p-2 border border-slate-300">
                <div class="flex justify-center items-center">
                  <button
                    @click="downloadImage()"
                    class="p-2 bg-blue-500 text-white rounded"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-download"
                      class="mr-1"
                    />
                    Зураг татах
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-else
        class="flex justify-center items-center h-full text-xl text-slate-500 font-bold"
      >
        Файл олдсонгүй.
      </div>
    </div>
  </div>

  <ErrorModal v-if="error" :error="error" />
</template>

<script>
import { onMounted, ref } from "vue";
import adminInstance from "@/lib/adminInstance";
import html2canvas from "html2canvas";
import ErrorModal from "@/components/ui/ErrorModal.vue";
import JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  name: "MMAdminMemberFiles",
  props: {
    answerId: Number,
    memberId: Number,
  },
  emits: ["closeAnswers"],
  components: {
    ErrorModal,
  },
  setup(props, { emit }) {
    const closeAnswers = () => {
      emit("closeAnswers");
    };

    const isAnswerLoading = ref(false);
    const assessmentFiles = ref([]);
    const assessmentResult = ref({});
    const assessmentAttachment = ref({});
    const error = ref(null);

    const fetchAssessmentAnswers = async () => {
      try {
        isAnswerLoading.value = true;
        const res = await adminInstance.get(
          `/get/member-files?answerId=${props.answerId}&memberId=${props.memberId}`
        );
        if (res.status === 200) {
          assessmentFiles.value = res.data.file.files;
          assessmentResult.value = res.data.file.result;
          assessmentAttachment.value = res.data.file.attachment;
        }
      } catch (err) {
        return err;
      } finally {
        isAnswerLoading.value = false;
      }
    };

    onMounted(async () => {
      await fetchAssessmentAnswers();
    });

    const downloadProofFiles = async (zipName) => {
      const zip = new JSZip();

      const fileFetches = assessmentFiles.value.map(async (file) => {
        try {
          const response = await fetch(file.proof_file);
          if (!response.ok) throw new Error("Failed to fetch file");

          const blob = await response.blob();

          const contentType = response.headers.get("Content-Type") || "";
          const extension = contentType.split("/")[1]?.split(";")[0] || "bin";
          const fileName = `${file.cid}.${extension}`;

          zip.file(fileName, blob);
        } catch (error) {
          console.error(`Error fetching file ${file.proof_file}`, error);
        }
      });

      await Promise.all(fileFetches);

      zip.generateAsync({ type: "blob" }).then((content) => {
        saveAs(content, `${zipName}-нотолгоо.zip`);
      });
    };

    const downloadFile = (fileUrl, title) => {
      fetch(fileUrl)
        .then((response) => {
          console.log("Status:", response.status);
          console.log("Content-Type:", response.headers.get("Content-Type"));

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          const contentType = response.headers.get("Content-Type") || "";
          const extension = contentType.split("/")[1]?.split(";")[0] || "bin";
          console.log(contentType, extension);

          return response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${title}.${extension}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          });
        })
        .catch((error) => {
          error.value = "Error while downloading file";
          setTimeout(() => {
            error.value = null;
          }, 5000);
        });
    };

    const contentToDownload = ref(null);
    const downloadImage = () => {
      html2canvas(contentToDownload.value, {
        allowTaint: true,
        useCORS: true,
      })
        .then((canvas) => {
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = "unelgee.png";
          link.click();
        })
        .catch((error) => {
          console.error("Error during canvas rendering: ", error);
        });
    };

    return {
      closeAnswers,
      assessmentFiles,
      isAnswerLoading,
      assessmentResult,
      assessmentAttachment,
      downloadProofFiles,
      downloadFile,
      contentToDownload,
      downloadImage,
      error,
    };
  },
};
</script>
